import { gql } from '@/lib/graphql/gql'

export const CREATE_APP_QUERY = gql`
  query CreateNewApp($idCompany: String!) {
    company(id: $idCompany) {
      id
      apps {
        id
        total
      }
      sevallaBilling {
        id
        creditUsage {
          id
          remainingCredits
        }
      }
      defaultPaymentMethod {
        id
        expYear
        expMonth
      }
      projects {
        id
        items {
          id
          displayName
        }
      }
    }
  }
`

export const CREATE_APP_MUTATION = gql`
  mutation CreateApplication(
    $idCompany: String!
    $idProject: String
    $source: AppSource!
    $dockerImage: String
    $idDockerRegistryCredential: String
    $repoUrl: String
    $defaultBranch: String
    $displayName: String!
    $idCluster: String!
    $gitType: GitType
    $idProcessResourceType: String
  ) {
    createApplication(
      source: $source
      dockerImage: $dockerImage
      idDockerRegistryCredential: $idDockerRegistryCredential
      repoUrl: $repoUrl
      defaultBranch: $defaultBranch
      displayName: $displayName
      idCompany: $idCompany
      idProject: $idProject
      idCluster: $idCluster
      gitType: $gitType
      idProcessResourceType: $idProcessResourceType
    ) {
      id
      name
    }
  }
`
